import { handledObjectTypeFieldName, defaultSurfaceRoughnessFieldName, surfaceStructureFieldName, defaultThroughLeakFieldName, surfaceCoatingFieldName, cardboardThroughLeakFieldName, cardboardSurfaceRoughnessFieldName, cardboardBoxSpecificationGroupName, releaseNotesGroupName, totalLiftingForceVerticalFieldName, totalLiftingForceHorizontalFieldName, requiredLiftingForceHorizontalFieldName, requiredLiftingForceVerticalFieldName, totalVolumeFieldName, } from "./constants";
export var getStringValue = function (group, fieldName) {
    var member = group.members.find(function (member) { return member.name === fieldName; });
    if (!member)
        return "";
    var field = member;
    return field.value;
};
export var getNumericalValue = function (group, fieldName) {
    var member = group.members.find(function (member) { return member.name === fieldName; });
    if (!member)
        return 0;
    var field = member;
    return Number(field.value);
};
/* The values for Calculation input will need to get their values for throughLeak and surfaceRoughness
 * from different groups based on the active application. If the application is cardboard we need the values to be fetched
 * from the box_specification_group whereas we otherwise get those values from the calculation_input_group. */
export var getCalculationInput = function (groups, calculationInputGroup) {
    var cardboardBoxSpecificationGroup = groups.find(function (group) { return group.name === cardboardBoxSpecificationGroupName; });
    var handledObjectType = getStringValue(calculationInputGroup, handledObjectTypeFieldName);
    var surfaceStructure = getStringValue(calculationInputGroup, surfaceStructureFieldName);
    var surfaceCoating = getStringValue(calculationInputGroup, surfaceCoatingFieldName);
    var surfaceRoughness = getNumericalValue(calculationInputGroup, defaultSurfaceRoughnessFieldName);
    var throughLeak = getNumericalValue(calculationInputGroup, defaultThroughLeakFieldName);
    if (cardboardBoxSpecificationGroup) {
        surfaceRoughness = getNumericalValue(cardboardBoxSpecificationGroup, cardboardSurfaceRoughnessFieldName);
        throughLeak = getNumericalValue(cardboardBoxSpecificationGroup, cardboardThroughLeakFieldName);
    }
    return {
        handledObjectType: handledObjectType,
        surfaceRoughness: surfaceRoughness,
        surfaceStructure: surfaceStructure,
        surfaceCoating: surfaceCoating,
        throughLeak: throughLeak,
    };
};
export var getOutput = function (group) {
    return {
        totalLiftingForceVertical: getNumericalValue(group, totalLiftingForceVerticalFieldName),
        totalLiftingForceHorizontal: getNumericalValue(group, totalLiftingForceHorizontalFieldName),
        requiredLiftingForceVertical: getNumericalValue(group, requiredLiftingForceVerticalFieldName),
        requiredLiftingForceHorizontal: getNumericalValue(group, requiredLiftingForceHorizontalFieldName),
        totalVolume: getNumericalValue(group, totalVolumeFieldName),
    };
};
export var getReleaseNotes = function (group) {
    var releaseNoteGroup = group.members.find(function (member) { return member.name === releaseNotesGroupName; });
    if (!releaseNoteGroup) {
        return;
    }
    var releaseNotes = releaseNoteGroup.members.map(function (member) {
        var _a;
        var releaseNoteField = member;
        var releaseNoteText = releaseNoteField.properties.release_note;
        var changes = releaseNoteText === null || releaseNoteText === void 0 ? void 0 : releaseNoteText.split("\\n");
        return {
            changes: changes !== null && changes !== void 0 ? changes : [],
            date: (_a = releaseNoteField.properties.date) !== null && _a !== void 0 ? _a : "",
            id: releaseNoteField.value,
        };
    });
    return releaseNotes.sort(function (a, b) { return new Date(b.date).getTime() - new Date(a.date).getTime(); });
};
